import React, { useEffect, useState } from "react";
import { Cuate } from "../assets/Order";
import AddressModal from "../modal/addressModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerAddress } from "../redux/actions/customerAddress";


export default function AddressPage({ selectedAddress, setSelectedAddress, proceed }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { address, error } = useSelector(
        (state) => state.customerAddressState
    );
  const dispatch=useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        dispatch(fetchCustomerAddress()); 
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [dispatch]);

  const formatAddress = (addr) => {
  if (!addr) return "";
  return [
    addr.buildingBlock ? addr.buildingBlock.toUpperCase() : "",
    addr.flatNo || "",
    addr.buildingName || "",
    addr.landmark || "",
    addr.streetName || "",
    addr.city || "",
    addr.pincode || ""
  ]
    .filter(Boolean) 
    .join(", ");
  };
  
    if (loading) {
    return <p className="text-center mt-10">Loading Address...</p>;
    }
  
    if(error)
    {
      return(
        <p className="text-red-600">{error}</p>
      );
    }
  
  return (
    <div className="flex flex-col md:flex-row border space-x-0 space-y-5 md:space-x-5 md:space-y-0  xl:space-x-10 border-gray-500 p-5 md:p-7 xl:p-10 rounded-lg w-full items-center">
    
    <div className="w-full md:w-1/2 ">
      <h2 className="text-sm md:text-base xl:text-xl font-semibold mb-4">Select Delivery Location</h2>
      <div className="border rounded p-4 space-y-3 text-xs md:text-sm xl:text-base">
        {address.length===0?(
          <p className="text-center col-span-full text-red-600 font-semibold py-8">
              No Address add yet.
          </p>
        ) : (
        address.map((address, index) => (
          <label key={index} className="flex items-center space-x-2">
            <input
              type="radio"
              name="delivery"
              checked={selectedAddress === address.id}
              onChange={() => setSelectedAddress(address.id)}
              className="accent-[#A63F40] cursor-pointer"
            />
            <span className="break-words cursor-pointer">
              {formatAddress(address)}
            </span>
          </label>
        )))}
        <div className="flex justify-center">
            <button className="mt-4 text-[#A63F40] px-5 py-2 border border-[#A63F40] rounded-md text-xs md:text-sm xl:text-base" 
            onClick={() => setOpen(true)}>+ Add Delivery Address</button>
        </div>
        
      </div>
      <div className="flex justify-center">
      <button
        onClick={() => selectedAddress && proceed()}
        disabled={!selectedAddress}
        className="mt-6 bg-[#A63F40] text-white px-6 py-2 rounded disabled:opacity-50 text-xs md:text-sm xl:text-base" 
      >
        Proceed
      </button>
      </div>
    </div>

    <div className="w-full md:w-1/2 md:pl-14 xl:pl-20">
        <img src={Cuate} alt="cuteimage" className=""/>
    </div>

    <AddressModal isOpen={open} onClose={() => setOpen(false)} />
    </div>
  );
}
